import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode"; // Importujemy jwtDecode

const HomePage = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    try {
      const token = localStorage.getItem("token");

      if (token) {
        // Dekodujemy token
        const decoded = jwtDecode(token);
        setUser({
          name: decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"] || "Guest",
          role: decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] || "Unknown",
        });
      } else {
        // Jeśli token nie istnieje, ustawiamy user na null
        setUser(null);
      }
    } catch (err) {
      console.error("Error decoding token or accessing localStorage:", err);
      setUser(null); // Jeśli jest błąd, ustawiamy user na null
    }
  }, []);

  return (
    <div className="text-center mt-12">
      <h1 className="text-3xl font-bold mb-4">Welcome to Event Planner App</h1>
      <p className="text-lg text-gray-600 mb-8">
        Your ultimate tool for managing and organizing events efficiently.
      </p>

      {user === null ? (
        // Wyświetlamy linki do logowania i rejestracji, jeśli użytkownik jest niezalogowany
        <div>
          <p className="text-gray-700">
            Please{" "}
            <Link to="/login" className="text-blue-500 hover:underline">
              Login
            </Link>{" "}
            or{" "}
            <Link to="/register" className="text-blue-500 hover:underline">
              Register
            </Link>{" "}
            to get started.
          </p>
        </div>
      ) : (
        // Wyświetlamy dane użytkownika, jeśli jest zalogowany
        <div>
          <h2 className="text-2xl font-semibold mb-2">Hello, {user.name}!</h2>
          <p className="text-lg text-gray-700 mb-6">
            You are logged in as <strong>{user.role}</strong>.
          </p>
          <div className="flex justify-center space-x-4">
            <Link
              to="/events"
              className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600"
            >
              View Events
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomePage;
